import { Upload, Loader2 } from "lucide-react";

export function DocumentsHeader({ canWrite, uploading, progress, fileRef, onUploadMany }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold tracking-tight text-slate-900">Il tuo Cassetto ESG</h1>
        <p className="text-sm text-slate-600 mt-1">
          Carica i documenti che hai già. ESG-PMI ti aiuta a trovare le informazioni utili: <strong>carica, conferma, fatto</strong>.
        </p>
      </div>
      {canWrite && (
        <div className="flex items-center gap-3">
          {uploading && (
            <div className="w-40" data-testid="upload-progress">
              <div className="h-2 rounded-full bg-slate-200">
                <div className="h-full rounded-full bg-green-700 transition-all" style={{ width: `${progress}%` }} />
              </div>
              <p className="text-xs text-slate-600 mt-1">{progress}%</p>
            </div>
          )}
          <input ref={fileRef} type="file" multiple className="hidden" data-testid="upload-document-input"
            accept=".pdf,.png,.jpg,.jpeg,.webp,.csv,.xlsx,.docx"
            onChange={(e) => onUploadMany([...(e.target.files || [])])} />
          <button type="button" disabled={uploading} onClick={() => fileRef.current?.click()}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-white bg-green-700 hover:bg-green-800 disabled:opacity-50 rounded-md px-4 py-2 transition-colors"
            data-testid="upload-document-button">
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" aria-hidden="true" /> : <Upload className="w-4 h-4" aria-hidden="true" />}
            Carica documenti
          </button>
        </div>
      )}
    </div>
  );
}
